"use client";

/**
 * First-login welcome tour for new users.
 *
 * The original zip used `react-joyride` v2; we-pdf relied on classic `callback`
 * + `CallBackProps` API. Joyride v3 is a breaking rewrite that doesn't cleanly
 * map to the zip's step config, and v2 has an unmet peer dep on React <=18 so
 * it warns loudly on our React 19 setup.
 *
 * For now this renders nothing. The tour is optional polish and can be added
 * back in a follow-up ticket once we either:
 *  - rewrite the step config against the v3 API, or
 *  - swap in a lighter tour library with React 19 support.
 *
 * Translation keys under `my-files.welcome-tour.*` are kept in all 8 locale
 * files so the content survives for the re-wiring.
 */
export function WelcomeTour() {
  return null;
}
